import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { ACCOUNT_REPORT_ID } from './accountReportId';

const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.SPENT.field,
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.CLICKS.field,
        FIELDS.CONVERSIONS.field,
        FIELDS.CPA.field,
        FIELDS.CVR.field,
        FIELDS.AVERAGE_CPC.field,
        FIELDS.VCTR.field,
        FIELDS.VCPM.field,
        FIELDS.CONVERSIONS_VALUE.field,
        FIELDS.ROAS.field,
    ].map(field => generateColumnId(ACCOUNT_REPORT_ID, field)),
    [REPORT_PRESET.SETUP]: [FIELDS.ACCOUNT_ID.field].map(field => generateColumnId(ACCOUNT_REPORT_ID, field)),
};

const defaultColumns = [
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.CLICKS.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.CVR.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.VCTR.field,
    FIELDS.VCPM.field,
].map(field => generateColumnId(ACCOUNT_REPORT_ID, field));

const performanceColumns = [
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.CLICKS.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.CVR.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.VCTR.field,
    FIELDS.VCPM.field,
    FIELDS.CONVERSIONS_VALUE.field,
    FIELDS.ROAS.field,
].map(field => generateColumnId(ACCOUNT_REPORT_ID, field));

export { customColumns, defaultColumns, performanceColumns };
